<div class="modal-header">
  <h5 class="modal-title">{{config.title}}</h5>
  <button (click)="close()" type="button" class="close">
    <i class="fas fa-times"></i>
  </button>
</div>
<div class="modal-body">

  <div class="row">
    <div class="offset-2 col-sm-8">
      <app-select-search bindValue="id"
                         bindLabel="name"
                         floatLabel="never"
                         [items]="rentals"
                         [ctrl]="form.get('rental')"
                         [multiple]="false"
                         placeholder="Select Rental">
        <ng-container class="error-container">
          <mat-error>
            Rental is <strong>required</strong>
          </mat-error>
        </ng-container>
      </app-select-search>

      <p>{{config.help}}</p>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-outline btn-default-outline text-uppercase">
    <i class="fal fa-times"></i> cancel
  </button>
  <button (click)="save(form)" type="button" class="btn btn-success text-uppercase create-btn">
    <i class="fal fa-save"></i> {{config.buttonText}}
  </button>
</div>
